<template>
  <v-container fluid class="login-shell pa-0">
    <v-row no-gutters class="fill-height">
      <v-col cols="12" md="6" class="login-brand">
        <div class="brand-top">
          <v-img src="../assets/cc.png" contain max-width="64" class="brand-logo"></v-img>
          <div>
            <div class="brand-name">CRECC</div>
            <div class="brand-subtitle">Centro de Recuperacion Emocional</div>
          </div>
        </div>

        <div class="brand-copy">
          <div class="eyebrow">Consejo Ciudadano</div>
          <h1>Una atencion mas clara empieza por escucharte.</h1>
          <p>Administra solicitudes, llamadas, citas y notas clinicas desde un mismo lugar.</p>
        </div>
      </v-col>

      <v-col cols="12" md="6" class="login-panel">
        <div class="login-card">
          <div class="login-heading">
            <span>Bienvenido de nuevo</span>
            <h2>Inicia sesion</h2>
            <p>Ingresa tus credenciales para acceder al sistema.</p>
          </div>

          <v-form v-model="validarFormulario" @submit.prevent="autenticar">
            <label class="field-label">Usuario</label>
            <v-text-field
              v-model="usuario"
              outlined
              height="54"
              prepend-inner-icon="mdi-account-outline"
              placeholder="Escribe tu identificador"
              :rules="usuarioRules"
            />

            <div class="password-row">
              <label class="field-label">Contrasena</label>
            </div>
            <v-text-field
              v-model="contrasena"
              outlined
              height="54"
              prepend-inner-icon="mdi-lock-outline"
              :append-icon="mostrarContrasena ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="mostrarContrasena ? 'text' : 'password'"
              placeholder="Escribe tu contrasena"
              :rules="contrasenaRules"
              @click:append="mostrarContrasena = !mostrarContrasena"
            />

            <v-btn
              block
              large
              depressed
              color="primary"
              class="login-button"
              type="submit"
              :disabled="!validarFormulario"
            >
              Ingresar al sistema
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-form>

          <div class="login-note">Usa las mismas credenciales del sistema anterior.</div>
        </div>

        <v-snackbar v-model="activarDesactivar" color="#1f2433" timeout="4200">
          {{ mensajeError }}
          <v-btn color="#e71d6f" text @click="activarDesactivar = false">Cerrar</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi.js'

export default {
  name: 'Login',
  data() {
    return {
      usuario: '',
      contrasena: '',
      mensajeError: '',
      respuesta: [],
      mostrarContrasena: false,
      activarDesactivar: false,
      usuarioRules: [
        value => !!value || 'Debe especificarse un usuario.'
      ],
      contrasenaRules: [
        value => !!value || 'Debe indicarse la contrasena.'
      ],
      validarFormulario: false
    }
  },
  methods: {
    autenticar() {
      ServiciosApi.verificaUsuario(this.usuario, this.contrasena)
        .then(response => {
          this.respuesta = response.data
          if (this.respuesta.status === 'ok') {
            sessionStorage.setItem('creccToken', this.respuesta.datos.token)
            this.$session.start()
            this.$session.set('nombre', this.respuesta.datos.nombre)
            this.$session.set('esAdmin', this.respuesta.datos.esAdmin)
            this.$session.set('idUsuario', this.respuesta.datos.id)
            this.$router.push('/')
          } else {
            this.mensajeError = 'No se encontro al usuario'
            this.activarDesactivar = true
          }
        })
        .catch(() => {
          this.activarDesactivar = true
          this.mensajeError = 'Ocurrio un error en el servidor, intente mas tarde'
        })
    }
  }
}
</script>

<style scoped>
.login-shell {
  min-height: 100vh;
  background: #ffffff;
}

.login-brand {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  color: #ffffff;
  background:
    radial-gradient(circle at 8% 32%, rgba(255,255,255,.18) 0 90px, transparent 92px),
    radial-gradient(circle at 88% 92%, rgba(255,255,255,.13) 0 180px, transparent 182px),
    linear-gradient(145deg, #8f0f46 0%, #6951dc 58%, #36b6a8 120%);
  padding: 56px 68px;
}

.login-brand::after {
  content: "";
  position: absolute;
  inset: auto -120px -160px auto;
  width: 420px;
  height: 420px;
  border: 1px solid rgba(255,255,255,.22);
  border-radius: 50%;
}

.brand-top {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 1;
}

.brand-logo {
  background: #ffffff;
  border-radius: 14px;
  padding: 8px;
}

.brand-name {
  font-size: 20px;
  font-weight: 800;
}

.brand-subtitle {
  font-size: 13px;
  opacity: .82;
}

.brand-copy {
  position: relative;
  z-index: 1;
  max-width: 620px;
  margin-top: 170px;
}

.eyebrow {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  opacity: .78;
  margin-bottom: 24px;
}

.brand-copy h1 {
  font-size: 56px;
  line-height: 1.08;
  font-weight: 900;
  letter-spacing: 0;
  margin-bottom: 28px;
}

.brand-copy p {
  max-width: 560px;
  font-size: 19px;
  line-height: 1.6;
  opacity: .9;
}

.login-panel {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}

.login-card {
  width: min(446px, 100%);
}

.login-heading span {
  color: #725bd6;
  display: block;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 2px;
  margin-bottom: 16px;
  text-transform: uppercase;
}

.login-heading h2 {
  color: #17213a;
  font-size: 40px;
  font-weight: 900;
  letter-spacing: 0;
  margin: 0 0 10px;
}

.login-heading p {
  color: #718097;
  font-size: 17px;
  margin-bottom: 30px;
}

.field-label {
  display: block;
  color: #20283a;
  font-size: 14px;
  font-weight: 800;
  margin-bottom: 8px;
}

.password-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.login-button {
  height: 56px !important;
  border-radius: 8px;
  background: linear-gradient(135deg, #8064e8, #5c3fc4) !important;
  color: #ffffff;
  font-weight: 800;
  letter-spacing: 0;
  margin-top: 8px;
}

.login-note {
  margin-top: 24px;
  padding: 14px;
  text-align: center;
  border-radius: 8px;
  color: #828da3;
  background: #f4f6fb;
  font-weight: 700;
  font-size: 13px;
}

@media (max-width: 959px) {
  .login-brand {
    min-height: 360px;
    padding: 36px 28px;
  }

  .brand-copy {
    margin-top: 70px;
  }

  .brand-copy h1 {
    font-size: 36px;
  }

  .login-panel {
    min-height: auto;
  }
}
</style>
